import { Grid, Typography } from "@material-ui/core";
import moment from "moment/moment";
import { useFluxoDeCaixaService } from "../../contexts";

export const ReportHeader = ({ reportType }) => {
  const { cachedPeriodResult: period, filters } = useFluxoDeCaixaService();

  return (
    <Grid item xs style={{ marginTop: 32 }}>
      <Typography variant="h4">
        Relatório de Fluxo de Caixa ({reportType})
      </Typography>
      <Typography variant="subtitle2">
        Período da busca:
        {moment(period?.startDate, filters.period === "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        )}{" "}
        até{" "}
        {moment(period?.endDate, filters.period === "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        )}
      </Typography>
    </Grid>
  );
};
